import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

const usePagingAfter = () => {
  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<PaginationLimit>(25);
  const [searchAfter, setSearchAfter] = useState<(number | string)[] | undefined>(undefined);
  const [prevSortId, setPrevSortId] = useState<(number | string)[] | undefined>(undefined);
  const [nextSortId, setNextSortId] = useState<(number | string)[] | undefined>(undefined);
  const [reverseSort, setReverseSort] = useState<boolean>(false);

  const router = useRouter();

  const onPageChange = (newSeriesData: string) => {
    setPage(Number(newSeriesData));
  };

  const onRowsPerPageChange = (newSeriesData: PaginationLimit) => {
    setRowsPerPage(newSeriesData);
    setSearchAfter(undefined);
    setReverseSort(false);
    setPage(1);
  };

  const resetPage = useCallback(() => {
    setSearchAfter(undefined);
    setReverseSort(false);
    setPage(1);
  }, []);

  const onPrevPageClick = useCallback(() => {
    setSearchAfter(prevSortId);
    setReverseSort(true);
    setPage((prevValue) => prevValue - 1);
  }, [prevSortId]);

  const onNextPageClick = useCallback(() => {
    setSearchAfter(nextSortId);
    setReverseSort(false);
    setPage((prevValue) => prevValue + 1);
  }, [nextSortId]);

  const onGoToSearchPress = (
    scope: 'loan-officers' | 'agents' | 'agents/teams' | 'opportunities'
  ) => {
    router.push(`/${scope}/search`);
  };

  return {
    page,
    rowsPerPage,
    resetPage,
    onGoToSearchPress,
    onPageChange,
    onRowsPerPageChange,
    onPrevPageClick,
    onNextPageClick,
    reverseSort,
    searchAfter,
    setNextSortId,
    setPrevSortId,
  };
};

export default usePagingAfter;
